import styled from 'styled-components';

export default styled.section`
	height: 100%;

	.errorMessageWrapper {
		left: 0;
		z-index: 2;
	}

	.entity-name-section:not(.group-input-textbox) {
		border-bottom: solid 0.1rem ${(props) => props.theme.color[`grey250`]};
		.motif-form-field {
			width: 70%;
		}
	}

	.entity-name-section {
		&.group-input-textbox {
			width: 5%;
		}
	}

	.domains-section {
		margin-top: 3rem;

		.domain-section-heading {
			display: block;
			margin: 0 0 1rem 0;
			padding: 0;
			font-size: 1.4rem;
			font-weight: 600;
			line-height: normal;
		}

		.domain-instructional-text {
			margin-bottom: 3rem;
			display: block;
			font-size: 1.4rem;
			line-height: 2rem;
		}

		.add-domain-buttons {
			margin-top: 3rem;
		}
	}

	.admin-wrap {
		.instructional-text {
			margin-bottom: 2rem;
		}
		.enter-description {
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			width: 96%;
			display: inline-block;
		}
	}

	.entity-wrap {
		margin-top: 2rem;
		border-top: solid 0.1rem ${(props) => props.theme.color[`grey250`]};
		padding-top: 3rem;
		.add-domain-buttons-container {
			margin-top: 3rem;
		}
		.domain-input-wrapper {
			margin-top: 2rem;
			.add-new-domain-wrap {
				width: 47%;
				margin-bottom: 2rem;
				.motif-typeahead-screen-reader {
					display: none;
				}

				.group-input-textbox {
					width: 100%;
				}
			}
			.add-existing-domain-wrap {
				width: 47%;
				.motif-select-input {
					height: 4.4rem;
					background: transparent;
					.motif-select-input-arrow {
						top: 1.4rem;
					}
					.motif-select-input-text {
						font-size: 1.4rem;
					}
				}
				.motif-form-field-select-input {
					width: 100%;
					.motif-label {
						top: 1.5rem;
						font-size: 1.2rem;
					}
				}
				.motif-form-field-select-input {
					&.motif-form-field-has-value {
						.motif-label {
							top: 0.5rem;
						}
					}
				}
			}
		}
	}
	.admin-wrap {
		ul {
			li {
				display: flex;
				align-items: flex-start;
				margin: 0 0 2rem 0;
				.remove-icon {
					min-height: 5rem;
					display: flex;
					align-items: center;
					svg {
						fill: ${(props) => props.theme.color[`black`]};
					}
				}
			}
		}
		.add-proj-owner-wrap {
			margin: 0;
			.search-box-wrapper {
				width: 22%;
				margin-left: 0;
			}
			.user-selectbox {
				.react-select__input {
					width: 90% !important;
				}
				.react-select__single-value {
					width: 80% !important;
					section {
						text-overflow: ellipsis;
						overflow: hidden;
						white-space: nowrap;
					}
				}
				.clearall {
					margin-top: 0;
					&.disabled {
						visibility: hidden;
					}
				}

				.enterdetail-description {
					margin-left: 0;
				}
			}
		}
	}
`;
